import React from 'react'

type FundReleaseErrorProps = {
  error: string
}

const FundReleaseError = ({ error }: FundReleaseErrorProps) => {
  switch (error) {
    case 'expired':
      return (
        <div className="text-center">
          <h3>Link Expired</h3>
          <p>
            This approval link has expired. Please contact your installer
            to send you a new fund release approval request.
          </p>
        </div>
      )
    case 'token_required':
    case 'invalid_token':
      return (
        <div className="text-center">
          <h3>Invalid Link</h3>
          <p>
            This approval link appears to be invalid. Please make sure you clicked the
            "Verify Information" button directly from the email you received, or copied
            the entire link without missing any characters.
          </p>
          <p>
            If you're still seeing this message, contact your installer to request a
            new approval link or a signed invoice if necessary.
          </p>
        </div>
      )
    default:
      return (
        <div className="text-center">
          <h3>Something Went Wrong</h3>
          <p>
            We were unable to load this fund release request.
            Please reach out to your installer for help and request a signed invoice if necessary.
          </p>
        </div>
      )
  }
}

export default FundReleaseError